import React from 'react'
import styled from 'styled-components'

import { MOBILE_BREAKPOINT } from 'broker/util/constants'

const Row = ({ className, children }) => (
  <div className={className}>
    {children}
  </div>
)

export default styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 420px;
  height: fit-content;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 8px 0;
  
  @media${MOBILE_BREAKPOINT} {
    flex-basis: 100%;
    justify-content: space-between;
    width: 100%;
    :first-child {
      margin-top: 16px;
    }
    
    :last-child {
      margin-bottom: 16px;
    }
  }
`
